<template>
  <div class="banner-container">
    <Slide
      :value="bannerSetting"
      :hidden-indicator="hiddenIndicator"
      :hide-video-controls="hideVideoControls"
      :loop-single-video="loopSingleVideo"
      :slide-arrow="slideArrow"
    />
  </div>
</template>

<script>
import Slide from './slide.vue'

export default {
  components: {
    Slide
  },
  props: {
    bannerSetting: {
      type: Object,
      require: true
    },
    hiddenIndicator: {
      type: Boolean,
      default: false
    },
    slideArrow: {
      type: String,
      default: 'hover'
    },
    hideVideoControls: {
      type: Boolean,
      default: false
    },
    loopSingleVideo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.banner-container {
  ::v-deep {
    .el-carousel__container {
      .slide-item {
        img,
        video {
          width: 1280px;
        }
      }
    }
  }
}
</style>
